/*
const accordionBtns = document.querySelectorAll(".accordion");

accordionBtns.forEach((accordion) => {
  accordion.onclick = function () {
    this.classList.toggle("is-open");

    let content = this.nextElementSibling;
    console.log(content);

    if (content.style.maxHeight) {
      //this is if the accordion is open
      content.style.maxHeight = null;
    } else {
      //if the accordion is currently closed
      content.style.maxHeight = content.scrollHeight + "px";
      console.log(content.style.maxHeight);
    }
  };
});
*/

$('.accordion').click(function(e) {
  
    let $this = $(this);
  
    if ($this.hasClass('is-open')) {
      $this.removeClass('is-open');
      $this.next().removeClass('show');
    } else {
      $this.addClass('is-open');
      $this.parent().siblings().find('.accordion-content').removeClass('show');
      $this.parent().siblings().find('.accordion').removeClass('is-open');
      $this.next().toggleClass('show');

      $('html,body').animate({
        scrollTop: $this.offset().top - 80
      }, 500); 
    }
});



$(document).ready(function() {

  select_diagram();

  $('#subwoofer_qty').on('change', function() {
    $(this).addClass('active');
  });

  $('#voice_coil_impedance').on('change', function() {
    $(this).addClass('active');
  });

  $('#view_wiring_option').click(function(){
    select_diagram(); 
  });

  $('.variant-input').click(function(){
    select_content();
  });

  $('.mobile-nav .collapsible-trigger').click(function(){
    $(this).parent().parent().toggleClass('active');
  });


  select_content();
  
});

function select_content() {
  $('.variant-input').each(function(){
    var variant_name = $(this).data('variant');
    
    if($('[data-variant=' + variant_name + '] input[type="radio"]').is(':checked')) {
      $('.' + variant_name).show().siblings('.variant_content ').hide();
    }
    //alert(variant_name);
  });
}

function select_diagram(){
  var subwoofer_qty =  $('#subwoofer_qty').val();
  var voice_coil_impedance = $('#voice_coil_impedance').val(); 

  if(subwoofer_qty == 1 && voice_coil_impedance == "dual_1"){
    $('#combination1').show();
  }else{
    $('#combination1').hide();
  }
  if(subwoofer_qty == 1 && voice_coil_impedance == "dual_2"){
    $('#combination2').show();
  }else{
    $('#combination2').hide();
  }
  if(subwoofer_qty == 1 && voice_coil_impedance == "dual_3"){
    $('#combination3').show();
  }else{
    $('#combination3').hide();
  }
  if(subwoofer_qty == 1 && voice_coil_impedance == "single_4"){
    $('#combination4').show();
  }else{
    $('#combination4').hide();
  }

  ///
  if(subwoofer_qty == 2 && voice_coil_impedance == "dual_1"){
    $('#combination5').show();
  }else{
    $('#combination5').hide();
  }
  if(subwoofer_qty == 2 && voice_coil_impedance == "dual_2"){
    $('#combination6').show();
  }else{
    $('#combination6').hide();
  }
  if(subwoofer_qty == 2 && voice_coil_impedance == "dual_3"){
    $('#combination7').show();
  }else{
    $('#combination7').hide();
  }
  if(subwoofer_qty == 2 && voice_coil_impedance == "single_4"){
    $('#combination8').show();
  }else{
    $('#combination8').hide();
  }

  ///
  if(subwoofer_qty == 3 && voice_coil_impedance == "dual_1"){
    $('#combination9').show();
  }else{
    $('#combination9').hide();
  }
  if(subwoofer_qty == 3 && voice_coil_impedance == "dual_2"){
    $('#combination10').show();
  }else{
    $('#combination10').hide();
  }
  if(subwoofer_qty == 3 && voice_coil_impedance == "dual_3"){
    $('#combination11').show();
  }else{
    $('#combination11').hide();
  }
  if(subwoofer_qty == 3 && voice_coil_impedance == "single_4"){
    $('#combination12').show();
  }else{
    $('#combination12').hide();
  }

  ///
  if(subwoofer_qty == 4 && voice_coil_impedance == "dual_1"){
    $('#combination13').show();
  }else{
    $('#combination13').hide();
  }
  if(subwoofer_qty == 4 && voice_coil_impedance == "dual_2"){
    $('#combination14').show();
  }else{
    $('#combination14').hide();
  }
  if(subwoofer_qty == 4 && voice_coil_impedance == "dual_3"){
    $('#combination15').show();
  }else{
    $('#combination15').hide();
  }
  if(subwoofer_qty == 4 && voice_coil_impedance == "single_4"){
    $('#combination16').show();
  }else{
    $('#combination16').hide();
  }
}